import { render, staticRenderFns } from "./Mapbox.vue?vue&type=template&id=4edbf896&scoped=true&"
import script from "./Mapbox.vue?vue&type=script&lang=js&"
export * from "./Mapbox.vue?vue&type=script&lang=js&"
import style0 from "./Mapbox.vue?vue&type=style&index=0&id=4edbf896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edbf896",
  null
  
)

export default component.exports